// import Eye from "assets/icons/eye.svg";
// import Apple from "assets/icons/apple.svg";
import {
  Box,
  Button as CButton,
  Container,
  FormControl,
  FormLabel,
  HStack,
  Image,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { VisibilityOffRounded, VisibilityRounded } from '@material-ui/icons';
import Google from 'assets/icons/google.svg';
// assets
import { ReactComponent as Logo } from 'assets/logos/s-logo.svg';
// import ls from "util/secureStorage";
// import constant from "config/constant";
import Button from 'components/Button/Button';
import Input from 'components/Input/Input';
import constant from 'config/constant';
import { toLower } from 'lodash';
// import Load from "assets/svg/other/loading2.svg";
//css
import 'pages/styles/auth/Login.css';
import React, { Component, createRef } from 'react';
import GoogleLogin from 'react-google-login';
import Recaptcha from 'react-google-recaptcha';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store';
import { get, post } from 'util/axiosLib';
import { logger } from 'util/logger';
import { getParameterByName } from 'util/utils';

const initialState = {
  email: null,
  password: null,
  emailError: '',
  passwordError: '',
  otherError: '',
  incorrectError: '',
  verifyHuman: '',
  doneCaptcha: false,
  captchaPassed: false,
  isSigningIn: false,
  isVisible: false,
};

export default function LoginComponent(props) {
  const { store, dispatch, login, hydrateToken, rDispatch } = useStore();
  const history = useHistory();

  // useEffect(() => {
  //   if (store && store.isSignedIn && store.token) {
  //     let redirectUrl = getParameterByName("redirectUrl");
  //     if (redirectUrl && redirectUrl[0] !== "/") {
  //       redirectUrl = "/" + redirectUrl;
  //     }

  //     const continueTo = redirectUrl ? redirectUrl : "/dashboard/home";
  //     console.log({continueTo, redirectUrl})
  //     history.push(continueTo);
  //     return;
  //   }
  //   // eslint-disable-next-line
  // }, [store?.isSignedIn]);

  return (
    <Login
      {...props}
      login={login}
      store={store}
      dispatch={dispatch}
      history={history}
      hydrateToken={hydrateToken}
      rDispatch={rDispatch}
    />
  );
}

class Login extends Component {
  recaptchaInstance = createRef();
  async componentDidMount() {
    // const btn = document.querySelector(".password-btn");
    // const pass = document.querySelector(".pass");
    this.getByPassCookie();

    // btn.addEventListener("click", function () {
    //   if (pass.type === "text") {
    //     pass.type = "password";
    //     btn.innerHTML = '<img class="show-icon" src="svg/eye.svg" />';
    //   } else {
    //     pass.type = "text";
    //     btn.innerHTML = '<img class="hide-icon" src="svg/eye-closed.svg" />';
    //   }
    // });

    // const { googleReCaptchaProps } = this.props;
    // if(googleReCaptchaProps.executeRecaptcha) {
    //   const token = await this.props.googleReCaptchaProps?.executeRecaptcha('login');
    //   console.log({token})
    // }
  }

  getByPassCookie = async () => {
    try {
      await get(`${process.env.REACT_APP_API_ENDPOINT}/auth/bypass`);
      return Promise.resolve(true);
    } catch (err) {}
  };

  // Input Validation

  state = initialState;

  validate = () => {
    let emailError = '';

    // if (!this.state.email.includes("@") || this.state.email.length < 4) {
    //   const element = document.getElementById("email");
    //   element.classList.add("inputs-error");
    //   emailError = "Please enter a valid email!";
    // } else {
    //   const element = document.getElementById("email");
    //   element.classList.remove("inputs-error");
    // }

    if (!this.state.email || this.state.email.length < 2) {
      const element = document.getElementById('email');
      element?.classList.add('inputs-error');
      emailError = 'Please enter a valid email!';
    } else {
      const element = document.getElementById('email');
      element?.classList.remove('inputs-error');
    }

    if (emailError) {
      this.setState({ emailError });
      return false;
    }

    return true;
  };

  loadUser = async (token) => {
    try {
      const headers = {
        authorization: `${token}`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      };

      const getUserReq = await get(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/currentUser`,
        headers
      );

      const userData = JSON.stringify(getUserReq.data.data);
      localStorage.setItem('btm_user', userData);
      this.props.dispatch({ type: 'LOGIN', payload: { userData, token } });
      return Promise.resolve(true);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  // Form submit function

  handleSubmit = async (event) => {
    try {
      this.setState((prev) => ({ ...prev, isSigningIn: true }));
      event.preventDefault();
      const isValid = this.validate();
      if (isValid) {
        // load gif
        // const loaded = document.getElementById("load");
        // loaded.classList.add("load-gif-on");

        // User login details
        const user = {
          email: this.state.email,
          password: this.state.password,
        };

        // if (navigator.onLine === true) {
        const captch = await this.recaptchaInstance.current?.executeAsync();

        this.recaptchaInstance.current?.reset();

        // console.log("LOGIN DETAILS", user);

        const loginReq = await post(
          `${process.env.REACT_APP_API_ENDPOINT}/v2/auth/signin`,
          { ...user, humanKey: captch }
        );

        // localStorage.setItem("emailVerify2", this.state.email);

        // const loaded = document.getElementById("load");
        // loaded.classList.remove("load-gif-on");
        this.setState((prev) => ({ ...prev, isSigningIn: false }));

        // const element = document.getElementById("email");
        // element.classList.remove("inputs-error");
        // const element2 = document.getElementById("pass");
        // element2.classList.remove("inputs-error");
        const errmsg = document.getElementById('error-info');
        errmsg.classList.remove('err-auth-on');
        this.setState({ incorrectError: ' ' });

        const token = loginReq.data.data.token;

        console.log('LOGIN RESPONSE', loginReq.data);
        // await this.loadUser(token); // Load user into the localstorage

        // ls.set(constant.AUTH_TOKEN_KEY, token);
        this.props.login(token, loginReq.data.data.exp);
        // localStorage.setItem("tokenset", token);

        let redirectUrl = getParameterByName('redirectUrl');
        if (redirectUrl && redirectUrl[0] !== '/')
          redirectUrl = '/' + redirectUrl;

        const continueTo = redirectUrl ? redirectUrl : '/dashboard/home';

        if (loginReq.data.data.twoFactor !== false) {
          this.props.hydrateToken({ token, isSignedIn: false });
          this.props.history.push(
            redirectUrl ? `/2faenter?redirectUrl=${redirectUrl}` : '/2faenter'
          );
        } else {
          this.props.login(
            token,
            loginReq.data.data.exp,
            true,
            loginReq.data.data
          );
          // this.props.history.push(continueTo);
          window.location = continueTo;
        }

        logger(loginReq);
        // } else {
        //   // const loaded = document.getElementById("load");
        //   // loaded?.classList.remove("load-gif-on");
        //   this.setState((prev) => ({ ...prev, isSigningIn: false }));
        //   this.setState({ otherError: "Please check your network connection" });
        // }
      }
    } catch (err) {
      try {
        logger('login ERROR::: ', err);
        this.setState((prev) => ({ ...prev, isSigningIn: false }));

        // console.log("AUTH TOKEN", err?.data?.token);
        // ls.set(constant.AUTH_TOKEN_KEY, {
        // token: err?.data?.token,
        // isSignedIn: false,
        // });
        this.props.hydrateToken({
          token: err?.data?.token,
          isSignedIn: false,
          // verification: err?.verification,
        });

        // this.props.rDispatch(fetchUserP)

        // this.props.rDispatch(
        //   persistTemporaryProfile({
        //     email: "user@gmail.com",
        //     phone: "+2347085160602",
        //   })
        // );

        if (err?.customError && err?.customError?.length > 1) {
          // const errData = err.response;
          // logger(errData.message);

          localStorage.setItem('emailVerify2', this.state.email);

          // logger("mail>", localStorage.getItem("emailVerify2"));

          // let redirectUrl = getParameterByName("redirectUrl", window.location);
          // if (redirectUrl && redirectUrl[0] !== "/")
          //   redirectUrl = "/" + redirectUrl;

          // const continueTo = redirectUrl
          //   ? `/confirmnumber?redirectUrl=${redirectUrl}`
          //   : "/confirmnumber";

          localStorage.setItem('userMail', this.state.email);

          // if (errData?.data?.error === "Phone verification is required") {
          //   //localStorage.setItem("userMail", this.state.email);
          //   //localStorage.setItem("userPassword", this.state.password);
          //   localStorage.setItem("tokentemp2", errData.data.data.token);
          //   logger(localStorage.getItem("tokentemp2"));

          //   setTimeout(() => {
          //     this.props.history.push(continueTo);
          //   }, 1500);
          // }

          if (
            toLower(err?.customError).includes('phone number is not verified')
          ) {
            // localStorage.setItem("tokentemp2", err);
            // logger(localStorage.getItem("tokentemp2"));

            setTimeout(() => {
              this.props.history.replace(constant.PAGES.VERIFY_EMAIL_PASSWORD);
              // window.location = `/confirmnumber`;
              // window.location = constant.PAGES.VERIFY_EMAIL_PASSWORD;
            }, 500);
          }

          if (toLower(err?.customError).includes('email is not verified')) {
            // localStorage.setItem("tokentemp2", errData.data.data.token);
            //logger("tokenUsed>>",localStorage.getItem("tokentemp2"));

            setTimeout(() => {
              // window.location = "/verifyemail";
              this.props.history.replace(constant.PAGES.VERIFY_EMAIL_PASSWORD);
              // window.location = constant.PAGES.VERIFY_EMAIL_PASSWORD;
            }, 500);
          }
          // const loaded = document.getElementById("load");
          // loaded?.classList.remove("load-gif-on");

          const errmsg = document.getElementById('error-info');
          errmsg?.classList.add('err-auth-on');

          this.setState({
            incorrectError: err?.customError ?? 'Something went wrong',
          });
          const element = document.getElementById('email');
          element?.classList.add('inputs-error');
          const element2 = document.getElementById('pass');
          element2?.classList.add('inputs-error');
        } else {
          this.setState({ otherError: 'Something went wrong' });
        }
      } catch (err) {}
    }
  };

  // Google Sign In

  successGoogle = async (response) => {
    // console.log(response);

    const googleId = {
      idToken: response.tokenId,
    };

    try {
      const googleLoginReq = await post(
        `${process.env.REACT_APP_API_ENDPOINT}/auth/social/verifyId`,
        googleId
      );

      this.setState({ isSigningIn: true });

      // load gif
      // const loaded = document.getElementById("load");
      // loaded.classList.add("load-gif-on");

      const token = googleLoginReq.data.data.token;
      // await this.loadUser(token); // Load user into the localstorage
      // localStorage.setItem("tokenset", token);

      console.log('GOOGLE SIGNIN RES', googleLoginReq.data);

      let redirectUrl = getParameterByName('redirectUrl', window.location);
      if (redirectUrl && redirectUrl[0] !== '/')
        redirectUrl = '/' + redirectUrl;

      const continueTo = redirectUrl ? redirectUrl : '/dashboard/home';

      if (googleLoginReq.data.data.twoFactor !== false) {
        this.props.hydrateToken({ token, isSignedIn: false });
        this.props.history.push(
          redirectUrl ? `/2faenter?redirectUrl=${redirectUrl}` : '/2faenter'
        );
      } else {
        this.props.login(token, googleLoginReq.data.data.exp);
        // this.props.history.push(continueTo);
        window.location = continueTo;
      }

      // if (googleLoginReq.data.data.twoFactor === false) {
      //   window.location = "/2fagenerate";
      // }
      // if (googleLoginReq.data.data.twoFactor !== false) {
      //   window.location = "/2faenter";
      // }

      // window.location = "/dashboard/home";

      //console.log(response.profileObj);
    } catch (err) {
      //console.log("AXIOS ERROR: ", err);
      console.log('GOOGLE SIGNIN ERROR', err);
      const gUserData = JSON.stringify(response.profileObj);
      localStorage.setItem('google_user', gUserData);
      const gUserData2 = JSON.parse(localStorage.getItem('google_user'));
      logger(gUserData2.email);

      this.setState({ otherError: 'Sorry user not found. Please Sign up' });

      // load gif
      // const loaded = document.getElementById("load");
      // loaded.classList.remove("load-gif-on");

      this.setState({ isSigningIn: false });

      let redirectUrl = getParameterByName('redirectUrl', window.location);
      if (redirectUrl && redirectUrl[0] !== '/')
        redirectUrl = '/' + redirectUrl;

      const continueTo = redirectUrl
        ? `/signup?redirectUrl=${redirectUrl}`
        : '/signup';

      setTimeout(() => {
        this.props.history.push(continueTo);
      }, 1600);
    }
  };

  failureGoogle = (response) => {
    console.log(response);
  };

  resetLocalStorage = () => {
    localStorage.removeItem('tokenset');
    localStorage.removeItem('btm_user');
    localStorage.removeItem('emailVerify');
    localStorage.removeItem('userMail');
    localStorage.removeItem('userPassword');
    localStorage.removeItem('tokentemp');
    localStorage.removeItem('walletData');
    localStorage.removeItem('ghBal');
    localStorage.removeItem('nairaBal');
    localStorage.removeItem('expired');
  };

  isDisabled = () =>
    !(
      this.state.email &&
      this.state.email.length > 1 &&
      this.state.password &&
      this.state.password.length > 2
    ) || this.state.isSigningIn;

  // <Box py={["10px", "20px"]}>
  //   <Container maxW="container.sm">
  //     <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
  // <VStack>
  //   <Box w={["100px", "initial"]} as={Logo} />
  //   <Heading as="h3" fontSize={["24px", "32px"]}>
  //     Welcome
  //   </Heading>
  //   <Text textAlign="center" fontSize={["32px", "44px"]}>
  //     Let's get you started
  //   </Text>
  //   <Text textAlign="center" fontSize={["sm", "md"]}>
  //     Fill in your details to create your account
  //   </Text>
  // </VStack>

  render() {
    this.resetLocalStorage();
    //localStorage.clear();
    return (
      <Box py={['10px', '20px']}>
        <Container maxW='lg'>
          <Box bg='#fcfcfc' p={['10px', '16px', '28px']}>
            <div className='sign-up-content'>
              <VStack>
                <Box w={['100px', 'initial']} as={Logo} />

                <Text
                  textAlign='center'
                  mt='30px !important'
                  fontSize={['32px', '44px']}
                >
                  Glad to have you back
                </Text>
                <Text textAlign='center' fontSize={['sm', 'md']}>
                  Fill in your details to log in
                </Text>
              </VStack>

              <div className='sign-up-body'>
                <Stack
                  as='form'
                  onSubmit={this.handleSubmit}
                  gridGap='8px'
                  mt='20px'
                >
                  {/* <div className="su-single-fields">
                      <input
                        className="su-single-inputs"
                        id="email"
                        type="text"
                        placeholder="Email/Username"
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                        required
                      />
                    </div> */}
                  <FormControl>
                    <FormLabel>Email</FormLabel>

                    <Input
                      w='100%'
                      value={this.state.email ?? ''}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      type='email'
                      name='email'
                      id='email'
                      isRequired
                      placeholder='Enter email'
                    />
                    <p className='errormsg'>{this.state.emailError}</p>
                  </FormControl>
                  {/* <div className="su-single-fields">
                      <input
                        className="su-single-inputs pass"
                        id="pass"
                        type="password"
                        placeholder="Password"
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        required
                      />
                      <span className="password-btn">
                        <img
                          className="show-icon"
                          id="password-btn"
                          src={Eye}
                          alt="show"
                        />
                      </span>
                    </div> */}
                  <FormControl mt='1rem'>
                    <FormLabel>Password</FormLabel>

                    <InputGroup>
                      <Input
                        w='100%'
                        value={this.state.password ?? ''}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        type={!this.state.isVisible ? 'password' : 'text'}
                        name='password'
                        id='password'
                        isRequired
                        placeholder='Enter password'
                      />
                      <InputRightElement
                        h='100%'
                        mr='12px'
                        children={
                          <Button
                            bg='transparent'
                            minW='0'
                            size='sm'
                            borderRadius='2'
                            onClick={() =>
                              this.setState({
                                isVisible: !this.state.isVisible,
                              })
                            }
                          >
                            {!this.state.isVisible ? (
                              <Box as={VisibilityRounded} color='#A0A3BD' />
                            ) : (
                              <Box as={VisibilityOffRounded} color='#A0A3BD' />
                            )}
                          </Button>
                        }
                      />
                    </InputGroup>
                  </FormControl>

                  <Link to='/forgot' className='green bold'>
                    Forgot password?
                  </Link>

                  <div className='flex justify-center mt-4'>
                    <Recaptcha
                      ref={this.recaptchaInstance}
                      sitekey={process.env.REACT_APP_RECAPTCHA}
                      size={'invisible'}
                    />
                  </div>

                  {/* <input className="su-submit " type="submit" value="Login" /> */}
                  {/* <div className="load-gif" id="load">
                      <img src={Load} alt="loading" />
                    </div> */}
                  <Button
                    isLoading={this.state.isSigningIn}
                    disabled={this.isDisabled()}
                    type='submit'
                    w='100%'
                    minH='56px'
                    id='login-button'
                  >
                    Login
                  </Button>
                  <div
                    id='error-info'
                    className='err-auth animate__animated animate__slideInDown'
                  >
                    {/* <p>
                      <strong>{this.state.incorrectError}</strong>
                    </p> */}
                    <Text
                      m='12px'
                      fontSize='sm'
                      className='errormsg2'
                      color='red.400'
                    >
                      {this.state.incorrectError}
                    </Text>
                  </div>
                  {/* <p className="errormsg2">{this.state.incorrectError}</p> */}
                </Stack>

                <VStack>
                  <p className='su-or'>OR</p>
                  <div className='su-alt-signin'>
                    {/* <button
                      onClick={this.handleApple}
                      className="su-apple right-m"
                    >
                      <img className="right-m2" src={Apple} alt="apple" />
                      Sign in with Apple
                    </button> */}
                    {/* <GoogleLogin
                      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      render={(renderProps) => (
                        <button
                          onClick={renderProps.onClick}
                          disabled={renderProps.disabled}
                          className="su-google"
                        >
                          <img className="right-m2" src={Google} alt="google" />
                          Sign in with Google
                        </button>
                      )}
                      onSuccess={this.successGoogle}
                      onFailure={this.failureGoogle}
                      cookiePolicy={"single_host_origin"}
                    /> */}
                    <GoogleLogin
                      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      onSuccess={this.successGoogle}
                      onFailure={this.failureGoogle}
                      cookiePolicy={'single_host_origin'}
                      render={(renderProps) => (
                        <CButton
                          // isLoading={isSigningInViaSocial}
                          onClick={renderProps.onClick}
                          disabled={renderProps.disabled}
                          _focus={{
                            borderColor: '#06C344',
                            boxShadow: '0 0 0 3px #06C3448f',
                          }}
                          border='1px solid #dadada'
                          h='56px'
                          borderRadius='16px'
                          px='12px'
                        >
                          <HStack>
                            <Image src={Google} alt='google' />
                            <Text fontWeight='400'>Sign In with google</Text>
                          </HStack>
                        </CButton>
                      )}
                    />
                    {/* <button onClick={this.handleGoogle} className="su-google">
                        <img className="right-m2" src={Google} alt="google"/>
                        Sign in with Google
                    </button> */}
                  </div>
                  <Text fontSize='sm' className='errormsg2' color='red.400'>
                    {this.state.otherError}
                  </Text>
                  <p className='su-bottom'>
                    {' '}
                    Don't have an account?{' '}
                    <Link to='/signup' className='green bold'>
                      {' '}
                      Sign up{' '}
                    </Link>
                  </p>
                </VStack>
              </div>
            </div>
          </Box>
        </Container>
      </Box>
    );
  }
}
